import { NotificationService } from './../../../shared/notification/notification.service';
import { Component, OnInit, Input, ViewEncapsulation, Inject } from '@angular/core';
import { InvoiceFinderContextService } from '../shared/invoice-finder-context.service';
import { AdjustmentType } from '../../shared/adjustment-types/adjustment-type.model';
import { AdjustmentTypeService } from '../../shared/adjustment-types/adjustment-type.service';
import { WriteOffInvoicesDto } from '../../shared/dto/write-off-invoices.dto';
import { UserService } from 'src/app/users/shared/user.service';
import { FinancialServiceService } from '../../shared/financial.service';
@Component({
  selector: 'wl-invoice-finder-write-off',
  templateUrl: './invoice-finder-write-off.component.html',
  styleUrls: ['./invoice-finder-write-off.component.less'],
    standalone: false
})
export class InvoiceFinderWriteOffComponent implements OnInit {
  get writeOffParams() {
    return this.writeOffDto;
  }
  set writeOffParams(value: WriteOffInvoicesDto) {
    this.writeOffDto = value;
  }
  public writeOffDto: WriteOffInvoicesDto;
  public adjustmentTypes: Array<AdjustmentType>;
  public get writeOffInvoicesCheck() {
    return this._context.isWriteOffOpen();
  }
  public set writeOffInvoicesCheck(value: boolean) {
    this._context.setWriteOffOpen(value);
  }
  public isGenerating = false;
  constructor(
    private _notificationService: NotificationService,
    private _adjustmentTypeService: AdjustmentTypeService,
    public _userService: UserService,
    private _financialService: FinancialServiceService,
    private _context: InvoiceFinderContextService
  ) {
    this.writeOffDto = {} as WriteOffInvoicesDto;
    this.writeOffDto.AdjustmentDate = new Date();
    this.writeOffDto.ApplyDate = new Date();
  }
  ngOnInit() {
    this._adjustmentTypeService.getAdjustmentTypes().then((data: Array<AdjustmentType>) => {
      this.adjustmentTypes = data;
    });
  }

  public cancelInvoiceWriteOff() {
    this.writeOffInvoicesCheck = false;
  }

  public writeOff() {
    this._context.getSelectedInvoices().then((invoices: Array<number>) => {
      this.writeOffDto.InvoiceNumbers = invoices;
      this._userService.getCurrentUser().then((user) => {
        this.writeOffDto.ChangedBy = user.UserName;
        this._userService.get(user.UserNum).then((users) => {
          this.writeOffDto.ProfileId = users.ProfileId;
        });
      });
      this._financialService
        .writeOffInvoices(this.writeOffDto)
        .then(() => {
          this._notificationService.translateSuccess('revenue.invoice-selector.actions.write-off-success');
          this.writeOffInvoicesCheck = false;
        })
        .catch((error) => {
          this._notificationService.httpError(error);
        })
        .finally(() => {
          this.isGenerating = false;
        });
    });
  }

  public open() {
    this.writeOffInvoicesCheck = true;
  }
}
